import ScreenLoader from './ScreenLoader';

export default ScreenLoader;
